import microuniversoApi from "app/api/microuniversoApi";
import { Classificacao, Profissao } from "app/types/comissoes/DadosBasicosIndicadores";
import { IIndicador } from "app/types/IIndicador"
import { Vendedor } from "app/types/Vendedor";
import { tratamentoErroPadrao } from "app/use-cases";
import { FormikErrors } from "formik";
import globalMU from "globalMU";
import React, { useState } from "react"
import { TelaDadosBasicos } from "./TelaDadosBasicos";

export type TelaDadosBasicosContainerProps = {
    dadosIndicador: IIndicador;
    classificacoes: Classificacao[];
    profissoes: Profissao[];
    formularioValidado: boolean;
    podeSalvar: boolean;
    onErrorValidacao: (erros: FormikErrors<IIndicador>) => void;
    manterDaodosTemporariosIndicador: (IIndicador: IIndicador) => void;
    onValidarFormulario: (valor: boolean) => void;
}

export const TelaDadosBasicosContainer = (props: TelaDadosBasicosContainerProps) => {
    const [cpfCnpjEValidado, setCpfCnpjEValidado] = useState(1);

    const [vendedoresRelacioanados, setVendedoresRelacioanados] = useState<Vendedor[]>([])

    const onValidarCpfCnpj = async (cpfCnpj: string) => {
        try {
            globalMU.blockUI();
            const resultadoObterTipoPessoa = await microuniversoApi.Comum.ObterTIpoPessoa(cpfCnpj, true)
            if (resultadoObterTipoPessoa != "F" && resultadoObterTipoPessoa != null) {
                globalMU.showErrorMessage(resultadoObterTipoPessoa)
            }
            setCpfCnpjEValidado(Number(await microuniversoApi.Comum.ValidarCpfCnpj(cpfCnpj)))
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    }

    const onVendedorModificado = async (filtro: string) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Vendedor.listarPorNomePessoa(filtro);
            if (!("HasErrors" in resultado)) {
                setVendedoresRelacioanados(resultado);
            }
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    }


    return (
        <>
            <TelaDadosBasicos
                dadosIndicador={props.dadosIndicador}
                classificacoes={props.classificacoes}
                profissoes={props.profissoes}
                podeSalvar={props.podeSalvar}
                vendedores={vendedoresRelacioanados}
                formularioValidado={props.formularioValidado}
                cpfCnpjEValido={cpfCnpjEValidado}
                onVendedorModificado={onVendedorModificado}
                onValidarFormulario={props.onValidarFormulario}
                onValidarCpfCnpj={onValidarCpfCnpj}
                manterDadosTemporarios={props.manterDaodosTemporariosIndicador}
                onErrorValidacao={props.onErrorValidacao}
            />
        </>
    )
}